import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingTopics() {
  const trending = articles.filter((a) => a.trending).slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14" aria-label="热门话题">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热门话题
          </h2>
        </div>
        <Link
          to="/category/shehui-redian"
          className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {trending.map((article, index) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group flex gap-4 p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
          >
            <div className="flex-shrink-0 w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center mt-1">
              <span className="text-xs font-bold text-primary-500">{index + 1}</span>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200 mb-1.5">
                {article.title}
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400 flex-wrap">
                <span>{article.publishDate}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line"></i>
                  {article.commentCount > 1000 ? `${(article.commentCount / 1000).toFixed(1)}k` : article.commentCount}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {article.readCount > 10000 ? `${(article.readCount / 10000).toFixed(1)}万` : article.readCount}
                </span>
              </div>
            </div>
            {index < 3 && (
              <div className="flex-shrink-0">
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                  热
                </span>
              </div>
            )}
          </Link>
        ))}
      </div>
    </section>
  );
}